import { render, staticRenderFns } from "./RoleOperate.vue?vue&type=template&id=fb4e4866&scoped=true&"
import script from "./RoleOperate.vue?vue&type=script&lang=js&"
export * from "./RoleOperate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb4e4866",
  null
  
)

export default component.exports